import { SettingsNotificationsPage } from "@/components/settings/notifications/page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/settings/notifications")({
  component: SettingsNotificationsPage,
});
